import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import Fade from "react-reveal/Fade";

function Gallery() {
  const navigate = useNavigate();

  const images = [
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2390_j-ERBuohc_xmAiV76uX.JPG?updatedAt=1682999801607",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2396_jxY1sgppL.jpg?updatedAt=1682999135218",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_47D27AA6-18B4-4ED8-9D79-BF7B4BD9CE93_Zf_i4bAig.JPG?updatedAt=1682999132398",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2314_nLzOJ8-cy.jpg?updatedAt=1682999132133",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2433_YnN4NjfA7.JPG?updatedAt=1682999133447",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2434_6f6XPryFU.JPG?updatedAt=1682999134988",
    "https://ik.imagekit.io/euo36lugk/Nutrire/img_6328_fX_H0Daoa.JPG?updatedAt=1682999138905",
    "https://ik.imagekit.io/euo36lugk/Nutrire/img_6446_kRQi-AWMT.JPG?updatedAt=1682999139826",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2432_9ArU6tf8N.JPG?updatedAt=1682999153688",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2430_CX4o8aneh.JPG?updatedAt=1682999154148",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_2431_GDPFNhz9X.JPG?updatedAt=1682999154150",
    "https://ik.imagekit.io/euo36lugk/Nutrire/image1_ykn6VLzozV.jpeg?updatedAt=1678609481148",
    "https://ik.imagekit.io/euo36lugk/Nutrire/image0_6CdsGwpwLH.jpeg?updatedAt=1678609479278",
    "https://ik.imagekit.io/euo36lugk/Nutrire/image2_9zYgRJ_KF.jpeg?updatedAt=1678609470599",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_3100_0PDd91VKQ.jpg?updatedAt=1678609448364",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5209_-aDpKve-8c.jpg?updatedAt=1678609446982",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5079_L5rPLpGBbU.jpg?updatedAt=1678609440969",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5018_p2dxd_iQw.jpg?updatedAt=1678609437530",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5158_ahrsictO9B.jpg?updatedAt=1678609430939",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5194_vtevEiGYm.JPG?updatedAt=1678609428113",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5197_NIVLasqSo.JPG?updatedAt=1678609427159",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5233_5QJbJCnG5.JPG?updatedAt=1678609427108",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5196_a2UlCE3Pn.JPG?updatedAt=1678609426339",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5213_Av8Nldikr.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606532049",
    "https://ik.imagekit.io/euo36lugk/Nutrire/Plump-416_nX-HkvbVx.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606532486",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5219_fSytNs9Q2S.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1672606533008",
    "https://ik.imagekit.io/euo36lugk/Nutrire/rachelbritt_F7XV6MX2J.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606534098",
    "https://ik.imagekit.io/euo36lugk/Nutrire/taylorutah_WH_FMsT1j.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606534282",
    "https://ik.imagekit.io/euo36lugk/Nutrire/oliviaorangecounty_AuCyZOxSPp.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606534816",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_3357_ueMfAwdZK.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606537942",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_3422_HaIgs7PQp.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606538535",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_3426_Mc2fD4AHf.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672606538567",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_8442_9q8qDeBOA.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1672607035616",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_5213_Bji2Z274u.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607036373",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_8443_kSo2wXtpM.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1672607036135",
    "https://ik.imagekit.io/euo36lugk/Nutrire/76698512-45BA-4581-93C3-68AAA7A70ECB_Qzr7jOf_G.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607036132",
    "https://ik.imagekit.io/euo36lugk/Nutrire/3BBE26C0-2BF1-42C8-8F23-0CA436BEC329_vroH31OQk.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607037082",
    "https://ik.imagekit.io/euo36lugk/Nutrire/IMG_3542_Lxyh_DB3v.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1672607036498",
    "https://ik.imagekit.io/euo36lugk/Nutrire/miala_3_6zqiZBF.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607038798",
    "https://ik.imagekit.io/euo36lugk/Nutrire/riverutah3_fme5rCWX9.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607040347",
    "https://ik.imagekit.io/euo36lugk/Nutrire/riverutah_dpnoBoTL9.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607040690",
    "https://ik.imagekit.io/euo36lugk/Nutrire/riverutah4_3niNl_Yuy.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607041176",
    "https://ik.imagekit.io/euo36lugk/Nutrire/riverutah2_E5eRuCRrv.JPG?ik-sdk-version=javascript-1.4.3&updatedAt=1672607041696",
    "https://ik.imagekit.io/euo36lugk/Nutrire/6_fHituGcLlF.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672607085771",
    "https://ik.imagekit.io/euo36lugk/Nutrire/10_7ycHx9xct.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672607087015",
    "https://ik.imagekit.io/euo36lugk/Nutrire/2_vWujqE6ho.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672607087130",
    "https://ik.imagekit.io/euo36lugk/Nutrire/7_uOUF9EkDeH.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672607087158",
    "https://ik.imagekit.io/euo36lugk/Nutrire/16_e0-gm5h_k.png?ik-sdk-version=javascript-1.4.3&updatedAt=1672607089132",
    "https://ik.imagekit.io/euo36lugk/Nutrire/4DA56DF0-7697-40A3-8C0F-C33F2FEC2ABD_-y-XuO5Z-.JPG?updatedAt=1687535605913",
    "https://ik.imagekit.io/euo36lugk/Nutrire/F2ADB271-0457-4B84-84A4-567FE5F60ABD_duxjQChGJ.JPG?updatedAt=1687535605022",
    "https://ik.imagekit.io/euo36lugk/Nutrire/0CCA70BD-982E-4DDF-8521-E2587756E483_uLWWhgb2OR.JPG?updatedAt=1687535604493",
  ];
  return (
    <Fade>
      <Container>
        <Galleryheader>
          <Left>
            <img onClick={() => navigate("/")} src="/images/back.png" alt="" />
          </Left>
          <Title>
            <h2>Work</h2>
          </Title>

          {/* <GalleryFilter>
          <label className="active-service-filter">Social Media</label>
          <label>Logo Design</label>
          <label>Models</label>
          <label>Brands</label>
        </GalleryFilter> */}
        </Galleryheader>
        <Photos>
          {images.map((image) => (
            <div className="photo-box" key={image}>
              <img src={image} />
            </div>
          ))}
          {/* <div className="photo-box">
          <img src="./images/photos/2.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/4.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/7.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/12.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/14.png" />
        </div>

        <div className="photo-box">
          <img src="./images/photos/18.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/11.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/6.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/19.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/12.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/11.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/10.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/2.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/4.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/7.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/12.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/14.png" />
        </div>

        <div className="photo-box">
          <img src="./images/photos/18.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/11.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/6.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/19.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/12.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/11.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/10.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/19.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/12.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/11.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/10.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/11.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/10.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/10.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/11.png" />
        </div>
        <div className="photo-box">
          <img src="./images/photos/10.png" />
        </div> */}
        </Photos>
      </Container>
    </Fade>
  );
}
// const FirstRow = styled.div`
//   display: grid;
//   grid-template-columns: repeat(5, 1fr);
//   /* grid-auto-rows: 250px; */
//   background-color: red;
//   grid-template-rows: 230px;
// `;
// const SecondRow = styled.div`
//   display: grid;
//   grid-template-columns: repeat(4, 1fr);
//   /* grid-auto-rows: 250px; */
//   background-color: red;
//   grid-template-rows: 230px;
// `;
// const Photobox = styled.div`
//   height: 100%;
//   width: 100%;
//   background-color: blue;
//   overflow: hidden;
//   img {
//     height: 100% !important;
//     width: 100% !important;
//     object-fit: cover;
//   }
//`;
const Photos = styled.div`
  width: 100%;
  margin: 0 auto;
  margin-top: 0px;
  background-color: #161616;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  grid-auto-rows: 250px;
  padding-top: 80px;
  grid-auto-flow: dense;
  ${this}.photo-box:nth-child(7n+1) {
    grid-column: span 2;
    grid-row: span 2;
  }
  .photo-box img {
    width: 102%;
    height: 102%;
    object-fit: cover;
  }
  .photo-box {
    overflow: hidden;
  }
`;
const Container = styled.div`
  position: relative;
  width: 100%;
  background-color: #fff !important;
  min-height: 100vh;
`;
const Galleryheader = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  padding-bottom: 30px;
  background: rgb(22, 22, 22);
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 5px 10px;
  background: linear-gradient(rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
`;

const Left = styled.div`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
  img {
    width: 30px;
  }
`;
const Title = styled.div`
  h2 {
    text-align: center;
    color: #c9a54e;
  }
`;

const GalleryFilter = styled.div`
  /* width: 65%; */

  display: flex;
  justify-content: center;
  label {
    min-width: 120px;
    padding: 5px 6px;
    background-color: #ececec;
    text-align: center;
    border-radius: 5px;
    font-size: 14px;
    margin-right: 10px;
    font-weight: 500;
  }
  .active-service-filter {
    background-color: #c9a54e;
    color: #fff;
  }
`;
export default Gallery;
